/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// assets
import CssField from '../Field.scss';
import CssCheckbox from './Checkbox.scss';

class Checkbox extends Component {
  static propTypes = {
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired,
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    meta: PropTypes.shape({
      form: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
    labelAfter: PropTypes.bool,
    labelBefore: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  };

  static defaultProps = {
    labelAfter: false,
    labelBefore: null,
  };

  static defaultProps = {
    label: null,
    className: '',
  };

  render() {
    const {
      input,
      label,
      meta: { form },
      className,
      labelAfter,
      labelBefore,
    } = this.props;
    const id = `${form}-${input.name}`;
    const labelEl = (
      <label htmlFor={id} className="field__label">
        {label}
      </label>
    );

    const labelBeforeEl = labelBefore ? (
      <label htmlFor={id} className="field__label field--label-before">
        {labelBefore}
      </label>
    ) : null;

    const defaultCheckedProp =
      typeof input.checked === 'undefined' ? { defaultChecked: input.value } : {};
    return (
      <div
        className={classNames(className, 'field', 'field--checkbox', {
          'field--label-after': labelAfter,
        })}
      >
        {labelAfter ? null : labelEl}
        {labelBeforeEl}

        <div className="field__wrapper">
          <input
            id={id}
            className="field__input"
            type="checkbox"
            {...input}
            {...defaultCheckedProp}
          />
          <div className="field__checkbox" />
        </div>
        {labelAfter ? labelEl : null}
      </div>
    );
  }
}

export default withStyles(CssField, CssCheckbox)(Checkbox);
